import React from "react";
import "./engineBayCleaning.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
// adjust image path if needed

export default function EngineBayCleaning() {
  return (
    <>
    <Helmet>
      <title>Best Engine Bay Cleaning Service in Palwal</title>
      <meta
        name="description"
        content="Keep your engine clean and efficient with professional engine bay cleaning service at AutoCare in Palwal. We offer safe and advanced engine cleaning techniques."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/engine-cleaning"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT CONTENT */}
        <div className="textContent">
          <h1>Best Engine Bay Cleaning Service in Palwal</h1>

          <p>
            Keep your engine clean, safe, and efficient with
            <strong> professional engine bay cleaning service</strong> at
            <span className="highlight"> AutoCare</span>.
            We are a trusted <span className="highlight">Auto Care in Palwal</span>
            offering expert <strong>car repair & detailing services</strong>
            with safe and advanced engine cleaning techniques.
          </p>

          <h2>What is Engine Bay Cleaning?</h2>
          <p>
            Engine bay cleaning is a careful detailing process that removes
            oil residue, dust, grease, and grime from your engine compartment
            without harming electrical components or sensors.
          </p>

          <h2>Benefits of Engine Bay Cleaning</h2>
          <ul>
            <li>Improves engine cooling & performance</li>
            <li>Helps detect oil leaks & worn parts early</li>
            <li>Prevents corrosion & long-term damage</li>
            <li>Enhances overall vehicle hygiene</li>
            <li>Increases resale value of your car</li>
          </ul>

          <h2>Why Choose AutoCare for Engine Bay Cleaning?</h2>
          <ul>
            <li>One of the <span className="highlight">best engine bay cleaning services in Palwal</span></li>
            <li>Safe cleaning methods for electrical components</li>
            <li>Professional tools & eco-friendly products</li>
            <li>Experienced technicians</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span> for car repair</li>
          </ul>

          <h2>Book Engine Bay Cleaning Near You</h2>
          <p>
            Looking for the <span className="highlight">best engine bay cleaning near me</span>?
            Choose <strong>AutoCare</strong> for safe, professional, and reliable
            engine cleaning services.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Engine Bay Cleaning
            </Link>
          </button>
        </div>

        {/* IMAGE CONTENT */}
        <div className="imageContent">
          <img
            src="/carServiceImages/EngineBayCleaning.webp"
            alt="Best Engine Bay Cleaning Service in Palwal by AutoCare"
          />
        </div>

      </div>
    </section>
    </>
  );
}
